import { render, staticRenderFns } from "./App.vue?vue&type=template&id=314351fe&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('314351fe')) {
      api.createRecord('314351fe', component.options)
    } else {
      api.reload('314351fe', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=314351fe&", function () {
      api.rerender('314351fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MWBJ/App.vue"
export default component.exports